"use client";

import { Box, Button, Typography } from "@mui/material";
import Masonry from "@mui/lab/Masonry";
import StorefrontIcon from "@mui/icons-material/Storefront";
import CommonLayout from "@/components/CommonLayout";
import { FamentoImageCard } from "@/components/FamentoImageCard";
import { CategoryDetail } from "@/types";
import { useToastMessageHandler } from "../ToastMessage";

const heights = [400, 500, 600, 700];

export const CategoryPageContent = ({
  category,
}: {
  category: CategoryDetail;
}) => {
  const { ToastMessage } = useToastMessageHandler();

  return (
    <>
      <ToastMessage />
      <CommonLayout
        title={category.title}
        subtitle={category.subtitle}
        imageUrl={category.hero}
      >
        {/* Purchasing Section */}
        <Box
          mb={6}
          p={2}
          textAlign="center"
          bgcolor="background.paper"
          border={1}
          borderRadius={2}
          borderColor="divider"
        >
          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            color="text.primary"
            fontWeight={600}
            mb={2}
          >
            Şimdi Alışverişe Başlayın
          </Typography>
          <Typography
            variant="body1"
            color="text.primary"
            mb={4}
            maxWidth={600}
            mx="auto"
            lineHeight={1.4}
          >
            El yapımı ürünlerimizi Shopier üzerinden güvenle satın
            alabilirsiniz. Hızlı kargo, güvenli ödeme ve daha bir sürü imkanları
            ile Shopier&apos;da alışveriş deneyiminizi en üst seviyeye çıkarın.
          </Typography>
          <Button
            href={category.shopierLink}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            size="large"
            sx={{ textTransform: "none" }}
            startIcon={<StorefrontIcon />}
          >
            Shopier&apos;dan Satın Al
          </Button>
        </Box>

        {/* Ürün Galerisi */}
        <Box mb={6}>
          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            fontWeight={600}
            textAlign="center"
          >
            Ürün Galerisi
          </Typography>
          <Typography variant="body1" textAlign="center" mb={6} mx="auto">
            Aşağıda &quot;{category.title}&quot; koleksiyonumuzun örneklerini
            görebilirsiniz. Her ürün el yapımı olduğu için küçük farklılıklar
            gösterebilir ve bu da ürünlerinizi benzersiz kılar.
          </Typography>
          <Box display="flex" justifyContent="center">
            <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={3}>
              {category.images?.map((img, i) => (
                <FamentoImageCard
                  key={i}
                  src={img}
                  alt={`${category.title} ürün örneği ${i + 1}`}
                  height={heights[i % heights.length]}
                  label="El Yapımı"
                />
              ))}
            </Masonry>
          </Box>
        </Box>
      </CommonLayout>
    </>
  );
};
